import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgModalFlexibleComponent } from './ng-modal-flexible.component';

@NgModule({
  declarations: [NgModalFlexibleComponent],
  imports: [CommonModule],
  exports: [NgModalFlexibleComponent]
})
export class NgModalFlexibleModule { }
